// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LQ6T","col":"styles_col__3yXBq"};